var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.667 0.666016H7.33366C6.41449 0.666016 5.66699 1.41352 5.66699 2.33268V5.66602H2.33366C1.41449 5.66602 0.666992 6.41352 0.666992 7.33268V15.666C0.666992 16.5852 1.41449 17.3327 2.33366 17.3327H10.667C11.5862 17.3327 12.3337 16.5852 12.3337 15.666V12.3327H15.667C16.5862 12.3327 17.3337 11.5852 17.3337 10.666V2.33268C17.3337 1.41352 16.5862 0.666016 15.667 0.666016ZM2.33366 15.666V7.33268H10.667L10.6687 15.666H2.33366ZM15.667 10.666H12.3337V7.33268C12.3337 6.41352 11.5862 5.66602 10.667 5.66602H7.33366V2.33268H15.667V10.666Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.01af56eca167a6246ffa18f425470a00.svg";
export { ForwardRef as ReactComponent };